import { ReactNode } from "react";
import { useLocation, Navigate } from "react-router";
import AuthService from "../utils/AuthService";
import { ROUTES, routeWithParams } from "./routes";
import MainLayout from "components/layout/MainLayout";
import { getCookieValue } from "utils";

const ProtectedRoute = (): ReactNode => {
  const location = useLocation();

  const companyPath = getCookieValue("companyPath");

  if (location.pathname === ROUTES.INDEX) {
    return (
      <Navigate
        to={routeWithParams(ROUTES.LOGIN, [companyPath || ""])}
        replace={true}
      />
    );
  }

  return AuthService.IsLoggedIn() ? (
    <MainLayout />
  ) : (
    <Navigate
      to={routeWithParams(ROUTES.LOGIN, [companyPath || ""])}
      state={{ from: location }}
      replace={true}
    />
  );
};

export default ProtectedRoute;
